import { add, vn } from 'vend-number'
import { isReturn } from '../sale'
import { ReduxCurrentSale } from '../../state/slices/currentSale/currentSaleSlice'
import { getNonKlarnaOutstandingBalance } from '../payments'
import { hasKlarnaPayments } from './klarna'

/**
 * Generic function for determining if a payment type should be disabled.
 *
 * @method shouldPreventOtherPayments
 *
 * @param {Number} amountTendered
 * @param {Sale} sale
 *
 * @return {Boolean} True if the payment type button should be disabled, false otherwise
 */
export const shouldPreventOtherPayments = (
  amountTenderedNum: number | string,
  sale: Pick<
    ReduxCurrentSale,
    'returnFor' | 'payments' | 'originalSalePayments'
  >
) => {
  // Disable other payment buttons when already paid by Klarna
  if (!isReturn(sale) && hasKlarnaPayments({ payments: sale.payments })) {
    return true
  }

  if (!isReturn(sale)) {
    return false
  }

  const amountTendered = vn(amountTenderedNum)

  // Handle exchange for higher value product during return sale
  if (!amountTendered.isNegative()) {
    return false
  }

  if (!hasKlarnaPayments({ payments: sale.originalSalePayments })) {
    return false
  }

  const nonKlarnaBal = vn(getNonKlarnaOutstandingBalance(sale))
  return !vn(add(nonKlarnaBal, amountTendered)).gte(0)
}
